import React, { FunctionComponent } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import styles from '../../CommonStyles/CommonGraphStyles.module.css';
import { Bar } from 'react-chartjs-2';
import { connect, useDispatch } from 'react-redux';
import { getTaskDrillDownChartOrg } from '../../Services/analytics';
import { setClearFilter, updateStage } from '../../Redux/actions';
import moment from 'moment';
import { changeDateForRoute } from '../../Services/contacts';
import Chart from "react-apexcharts";
import {themeColors} from "../../Components/theme";

type props = {
  analyticsData: any;
  type: 'Pending' | 'Completed' | 'Overdue';
  color: string[];
  style?: any;
  role: any;
  history: any;
  contacts: any;
  filter: 'MTD' | 'YTD' | 'PM' | 'All' | 'CUSTOM';
  organizationUsers: any[];
  user: any;
  teamLeadUsers: any[];
  theme: any;
};

const TaskBarChartOrg: FunctionComponent<props> = ({
  analyticsData,
  type,
  color,
  style,
  role,
  history,
  contacts,
  filter,
  organizationUsers,
  user,
  teamLeadUsers,
  theme
}) => {
  const [data, setData] = useState<any>({});
  const [allContacts, setAllContacts] = useState<any[] | undefined>(undefined);
  const [labels, setLabels] = useState<any>([]);
  const [series, setSeries] = useState<any>([]);
  const [total, setTotal] = useState<any>(0);

  useEffect(() => {
    let contact: any[] = [];
    Object.keys(contacts.data).forEach((key) => {
      contact = [...contact, ...contacts.data[key]];
    });
    setAllContacts(contact);
  }, [contacts.data]);
  useEffect(() => {
    const temp: { [key: string]: number } = {};

    Object.values(analyticsData).forEach((analytics: any) => {
      Object.keys(analytics.totalTaskCount[type]).forEach((tasks) => {
        if (temp[tasks]) {
          temp[tasks] += analytics.totalTaskCount[type][tasks];
        } else {
          temp[tasks] = analytics.totalTaskCount[type][tasks];
        }
      });
    });
    const sortable = Object.entries(temp)
    .sort(([,a],[,b]) => b-a)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
    setData(sortable);
    setData(sortable);
  }, [analyticsData]);

  useEffect(() => {
    let labels = Object.keys(data);
    let series = Object.values(data);
    let total = 0;
    series.map((item: any) => {
      total += item;
    });
    setLabels(labels);
    setSeries(series);
    setTotal(total);
  }, [data]);

  const chartData = {
    labels: Object.keys(data),
    datasets: [
      {
        label: `${type} Task Summary`,
        backgroundColor: color,
        borderColor: color,
        barThickness: 40,
        borderWidth: 2,
        data: Object.values(data),
      },
    ],
  };

  const donutChartOptions:any = {
    series: series,
    options: {
      chart: {
        animations: {
          enabled: false,
          // easing: 'easeinout',
          // speed: 800,
          // animateGradually: {
          //     enabled: true,
          //     delay: 150
          // },
          // dynamicAnimation: {
          //     enabled: true,
          //     speed: 350
          // }
      },
        background: theme ? 'rgba(0, 0, 0, 0)' : 'rgba(26, 43, 60, 1)',
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            // reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              // dateFormatter(timestamp) {
              //   return new Date(timestamp).toDateString()
              // }
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
          autoSelected: 'zoom' 
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val:any) {
          return val.toFixed(0) + "%"
        },
      },
      labels: labels,
      colors: ["#ff6961","#ff2400",  "#b92e34"],
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        floating: false,
        fontSize: '12px',
        labels: {
          colors: theme ? "#000":"#fff",
        }
    },
      plotOptions: {
        pie: {
          customScale: 0.9,
          donut: {
            size: "60%",
          },
          offsetY: 20,
        },
        stroke: {
          colors: undefined,
        },
      },
      // plotOptions: {
      //   pie: {
      //     donut: {
      //       labels: {
      //         show: true,
      //       },
      //       // total: {
      //       //   show: true,
      //       //   showAlways: true,
      //       //   fontSize: "22px",
      //       //   fontFamily: "Helvetica, Arial, sans-serif",
      //       //   fontWeight: 600,
      //       //   label: 156,
      //       //   color: "#0065bd",
      //       //   formatter: function (w: any) {
      //       //     return "Aman";
      //       //   },
      //       // },
      //     },
      //   },
      // },
    },
  };

  const customRadialBarChartOptions = {
    series: series,
    options: {
      chart: {
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: "25%",
            background: "transparent",
            image: undefined,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
            // total: {
            //   show: true,
            //   label: "Total",
            //   formatter: function (w: any) {
            //     return total;
            //   },
            // },
            formatter: function (val: any, opts: any) {
              return opts.w.config.series[opts.seriesIndex];
            },
          },
        },
      },
      colors: ["#87CBAC", "#aaf0d1", "#addfad"],
      labels: labels,
      legend: {
        show: true,
        labels: {
          colors: theme ? "#000":"#fff",
        }
      },
    },
  };
  const barChartOptions:any = {
    series: [
      {
        name: "Total",
        data: series,
      },
    ],
    options: {
      chart: {
        animations: {
          enabled: false,
          // easing: 'easeinout',
          // speed: 800,
          // animateGradually: {
          //     enabled: true,
          //     delay: 150
          // },
          // dynamicAnimation: {
          //     enabled: true,
          //     speed: 350
          // }
      },
        background: theme ? 'rgba(0, 0, 0, 0)' : 'rgba(26, 43, 60, 1)',
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            // reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              // dateFormatter(timestamp) {
              //   return new Date(timestamp).toDateString()
              // }
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
          autoSelected: 'zoom' 
        }
      },
      colors: ["#fada5f", "#fffe7a", "#fff44f"],
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
          dataLabels: {
            position: 'top',
          }
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          // fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'bold',
          colors: theme ? ["#000"]:["#fff"],
      },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: labels,
        labels: {
          show: true,
          style: {
            colors: theme ? "#000":"#fff",
        },
        },
      },
      yaxis: {
        labels: {
          show: true,
          style: {
            colors: theme ? "#000":"#fff",
        },
        },
      },
      fill: {
        opacity: 1,
      },
      // tooltip: {
      //   y: {
      //     formatter: function (val) {
      //       return "$ " + val + " thousands"
      //     }
      //   }
      // }
      legend: {
        show: false,
      }
    },
  };

  const pieChartOptions:any = {
    series: series,
    options: {
      chart: {
        animations: {
          enabled: false,
          // easing: 'easeinout',
          // speed: 800,
          // animateGradually: {
          //     enabled: true,
          //     delay: 150
          // },
          // dynamicAnimation: {
          //     enabled: true,
          //     speed: 350
          // }
      },
        background: theme ? 'rgba(0, 0, 0, 0)' : 'rgba(26, 43, 60, 1)',
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            // reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              // dateFormatter(timestamp) {
              //   return new Date(timestamp).toDateString()
              // }
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
          autoSelected: 'zoom' 
        }
      },
      labels: labels,
      dataLabels: {
        enabled: true,
        formatter: function (val:any) {
          return val.toFixed(0) + "%"
        },
      },
      colors: ["#87CBAC", "#aaf0d1", "#addfad"],
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        floating: false,
        fontSize: '12px',
        labels: {
          colors: theme ? "#000":"#fff",
        }
      }
    },
  };

  const dispatcher = useDispatch();
  return (
    // <div className={styles.graphBox} style={style}>
    //   <Bar
    //     data={chartData}
    //     options={{
    //       scales: {
    //         x: {
    //           grid: {
    //             display: false
    //           }
    //         },
    //         y: {
    //           grid: {
    //             display: false
    //           }
    //         }
    //       },
    //       responsive: true,
    //       maintainAspectRatio: false,
    //       plugins: {
    //         legend: {
    //           display:false
    //         },
    //       },
    //     }}
    //   />
    // </div>
    <>
    {type == "Completed" ? (
      <Chart
        options={pieChartOptions.options}
        series={pieChartOptions.series}
        type="pie"
        width={"100%"}
        height={280}
      />
    ) : type == "Pending" ? (
      <Chart
        options={barChartOptions.options}
        series={barChartOptions.series}
        type="bar"
        width={"100%"}
        height={280}
      />
    ) : (
      <Chart
        options={donutChartOptions.options}
        series={donutChartOptions.series}
        type="donut"
        width={"100%"}
        height={280}
      />
    )}
  </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    user: state.user.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(TaskBarChartOrg);
